<template>
  <div>
    <h2 class="header">Notifications</h2>
    <div class="inbox-parent">
      <el-button @click="dismissAllMessages"> Dismiss all </el-button>

      <el-divider></el-divider>

      <div class="inbox-body" v-for="message in this.inbox" :key="message.inboxmessageid" >
        <!-- {{ message.title }}
        <br /> -->

         <div class="date-parent">
          <p class="date">
            {{ message.datecreated | moment("timezone", $timeZone, "MMM DD YYYY hh:mm A") }}
          </p>
        </div>

        <div class="user-pic">
              <el-avatar style=" vertical-align: middle; margin-right: 10px;" size="medium" :src="message.fromuserimageurl" ></el-avatar>
        </div>

        <div class="message-info">
          <p>
            <span class="from-user">
            {{message.fromuserfullname}}
            </span>

            <span v-if="message.inboxmessagetypename == 'log'">
            added note to machine <span style="font-weight: bold;"> {{message.title}}</span>:
            </span>

            <span v-if="message.inboxmessagetypename == 'comment'">
              commented on Work Order  <span style="font-weight: bold;">{{message.title}}</span>:
            </span>
          </p>
        </div>

        <div style="display:flex;">
           <div style="flex-grow: 1;"  @click.once="dismissOneMessage(message)" >

                <router-link  
                  v-if="message.issueid == null" 
                  :to="{ path: `MachinebyId/${message.machineid}`}" >
                        <p class="message-text">  {{ message.body }} </p>
                </router-link>

                <router-link 
                  v-if="message.issueid != null && message.machineid != null" 
                  :to="{ path: `MachinebyId/${message.machineid}#issue-${message.issueid}`}">
                        <p class="message-text">  {{ message.body }} </p>
                </router-link>

                <router-link 
                  v-if="message.issueid != null && message.machineid == null" 
                  :to="{ path: `AllIssues#issue-${message.issueid}`}">
                        <p class="message-text">  {{ message.body }} </p>
                </router-link>

           </div>

           <div  @click.once="dismissOneMessage(message)" >
              <i style="cursor: pointer;" class="fas fa-times" ></i>
           </div>
        </div>

        <el-divider style="margin: 0px" ></el-divider>
        
      </div>
  </div>
    <!--<table id="firstTable">
      <thead>
        <tr>
          <th></th>
          <th>title</th>
          <th>message</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="message in this.inbox.messagelist" :key="message">
          <td></td>
          <td>{{ message.title }}</td>
          <td>{{ message.body }}</td>
        </tr>
      </tbody>
    </table>-->
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
import EventBus from '@/services/EventBus.js';
import { mapActions } from "vuex";


export default {
  data() {
    return {
      inbox: [],
      readMessagesIds:[]
    };
  },
  created() {
    EventService.getInbox().then(response => {
      this.inbox = response.data.inboxmessagetoreturn;
    });
    
     this.newTitle("Inbox");

    // EventBus.$emit('inbox-page-opened');

  },
  methods:{
    ...mapActions([ "newTitle"]),
    
    dismissOneMessage(message){

      // even a single message needs to be in array, because that's what the API is taking
      var readMessagesIds = [message.inboxmessageid];

      this.markMessageRead(readMessagesIds);
    },
    dismissAllMessages(){
      var readMessagesIds = this.inbox.map(a => a.inboxmessageid);
      this.markMessageRead(readMessagesIds);
    },
    markMessageRead(readMessagesIds){
      EventService.markInboxMsgsRead(readMessagesIds).then( response => {
        // if read msgs is 1 then a single message was dismissed, delete specific message. else, delete all.

        if(readMessagesIds.length == 1)
        {
          var indexOfDismissedMsg = this.inbox.map(e => e.inboxmessageid).indexOf(readMessagesIds[0])

          this.$delete(this.inbox, indexOfDismissedMsg);
        }
        else
        {
          this.inbox = [];
        }

        EventBus.$emit('inbox-message-dismissed', readMessagesIds.length);
      })
    }
  }
};
</script>

<style scoped>
.header{
  margin: 40px;
  margin-top: 75px;
}
.inbox-parent{
  margin: 40px;
}
.from-user{
  font-weight: bold
}
.message-info{
  display: inline-block;
}
.user-pic{
    display: inline-block;
}
.message-text{
  margin-left: 50px;
  word-wrap: break-word;
}
.date-parent{
text-align: right;
}
.date{
   margin: 5px;
   font-size: 13px;
}

@media (min-width: 250px) and (max-width: 979px) {
.message-info{
  display: block;
}
.message-text{
  margin-left: 25px;
}
.date{
font-size: 12px;
}
}
</style>